import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/** AUT-633 — the header of the order-steps table, columns left to right. */
const COLUMNS = ['label', 'kinds', 'order', 'requiresAct', 'retired'] as const;

export const DealStagesHead = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <TableHead>
      <TableRow>
        {COLUMNS.map((column) => (
          <TableCell key={column}>{t(`config.stages.columns.${column}`)}</TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
